import ACTIONS from '../constants/actions';
import Offer from '../decorators/offer';
import constants from '../constants';

const DEFAULT_PAGINATOR = {
  page: 1,
  per_page: 15
};

export const initialState = {
  articles: [],
  currentArticle: null,
  preloading_next_articles_page: false,
  otherArticles: [],
  articleOffers: [],
  events: [],
  currentEvent: null,
  stocks: [],
  currentStock: null,
  paginator: {
    ...DEFAULT_PAGINATOR
  },
  stocksOffers: []
};

const articlesReducer = function(state = initialState, action) {
  const actionHandlers = {
    [ACTIONS.FETCH_ARTICLES_SUCCESS]() {
      return {
        ...state,
        articles: [...(action.payload.append ? state.articles : []), ...action.payload.articles],
        paginator: action.payload.paginator,
        preloading_next_articles_page: false
      };
    },
    [ACTIONS.FETCH_ARTICLE_SUCCESS]() {
      return {
        ...state,
        currentArticle: action.payload.article
      };
    },
    [constants.ACTIONS.PRELOAD_ARTICLES_NEXT_PAGE]() {
      return {
        ...state,
        paginator: {
          ...state.paginator,
          page: state.paginator.page += 1
        },
        preloading_next_articles_page: true
      };
    },

    [ACTIONS.FETCH_EVENTS_SUCCESS]() {
      return {
        ...state,
        events: action.payload.events,
        paginator: action.payload.paginator
      };
    },
    [ACTIONS.FETCH_EVENT_SUCCESS]() {
      return {
        ...state,
        currentEvent: action.payload.event
      };
    },
    [ACTIONS.FETCH_STOCKS_SUCCESS]() {
      return {
        ...state,
        stocks: action.payload.stocks
      };
    },
    [ACTIONS.FETCH_STOCK_SUCCESS]() {
      return {
        ...state,
        currentStock: action.payload.stock
      };
    },
    [ACTIONS.FETCH_STOCKS_PRODUCTS_SUCCESS]() {
      return {
        ...state,
        stocksOffers: action.payload.offers.map(p => (new Offer(p)))
      };
    },
    [ACTIONS.FETCH_STOCK_PRODUCTS_SUCCESS]() {
      const stock = state.currentStock;
      stock.offers = action.payload.offers.map(p => (new Offer(p)));

      return {
        ...state,
        currentStock: stock
      };
    },
    [ACTIONS.FETCH_ARTICLE_OFFERS_SUCCESS]() {
      return {
        ...state,
        articleOffers: action.payload.offers.map(p => (new Offer(p)))
      };
    },
    [ACTIONS.RESET_ARTICLE_OFFERS]() {
      return {
        ...state,
        articleOffers: []
      };
    },
    [ACTIONS.FETCH_OTHER_ARTICLES_SUCCESS]() {
      return {
        ...state,
        otherArticles: action.payload.articles
      };
    },
    [ACTIONS.RESET_OTHER_ARTICLES]() {
      return {
        ...state,
        otherArticles: []
      };
    },
  };

  if (action.type in actionHandlers) {
    return actionHandlers[action.type]();
  }

  return state;
};

export default articlesReducer;
